<div class="home-container">
  <div class="welcome-section">
    <h1>Welcome to Charity Central</h1>
    <p class="subtitle">A MiExact Product</p>
    
    <!--<div class="feature-cards">
      <div class="feature-card">
        <h3>Reading</h3>
        <p>View and analyze will and probate documents with PDF display capabilities.</p>
        <a routerLink="/reading" class="feature-link">Go to Reading →</a>
      </div>
      
      <div class="feature-card">
        <h3>Reporting</h3>
        <p>Generate comprehensive reports for probate and will documentation.</p>
        <a routerLink="/reporting" class="feature-link">Go to Reporting →</a>
      </div>
      
      <div class="feature-card">
        <h3>Charity Database</h3>
        <p>Access and manage charity organization information and records.</p>
        <a routerLink="/charity-database" class="feature-link">Go to Charity Database →</a>
      </div>
      
      <div class="feature-card">
        <h3>PAF Matching</h3>
        <p>Perform postal address file matching and validation services.</p>
        <span class="feature-link disabled">Coming Soon</span>
      </div>
    </div>-->
  </div>
</div>
